<template>
  <div class="create-appo h-full">
    <div v-if="locations.length > 1 && !selectedLocation">

      <vs-row vs-justify="center">
        <vs-card
          class="cardx px-6 py-4 tasks-today__task"
          :class="{ 'cursor-pointer': location.miniWebsite }"
          v-for="location in locations"
          :key="location.idLocation"
          @click.native="location.miniWebsite ? selectedLocation = location : null"
          :actionable="!!location.miniWebsite"
        >
          <div class="vx-row">
            <vs-avatar v-if="cachedFiles[location.idLogo]" :src="'data:image/png;base64,' + cachedFiles[location.idLogo]" size="80px" />
            <vs-avatar v-else class="vs-avatart-location-medium cursor-default" size="80px" />
            <div class="vx-col w-full sm:w-auto flex flex-col justify-center">
              <span class="text-3xl text-primary mb-2">
                <!-- <vs-icon size="medium" icon="location_city"></vs-icon> -->
                {{location.nameOnline || location.name}}
              </span>
              <span v-if="location.phoneOnline || location.phone">
                <a @click.stop :href="'tel:' + (location.phoneOnline || location.phone)">
                  <vs-icon icon="phone" size="small" color="primary"></vs-icon>
                  {{ location.phoneOnline || location.phone }}
                </a>
              </span>
              <vs-alert icon="warning" v-if="!location.miniWebsite" class="mt-3">
                Pobočka nemá aktivované online objednávání
              </vs-alert>
            </div>
          </div>
        </vs-card>
      </vs-row>
    </div>

    <div v-if="selectedLocation" class="h-full">
      <div v-if="selectedLocation.miniWebsite" class="h-full">
        <iframe v-if="isMobile()" :src="onlineBookingUrl()" frameborder="0" class="w-full h-full"></iframe>
        <vs-row v-else vs-justify="center" class="online-booking-card">
          <vs-col type="flex" vs-justify="center" vs-align="center" class="vs-col-online-booking" style="width: 863px;">
            <vs-card class="vc-card-online-booking">
              <iframe :src="onlineBookingUrl()" frameborder="0" class="online-booking"></iframe>
            </vs-card>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import { mapGetters } from "vuex";
  import Avatar from "../Avatar.vue";
  import helpers from '../../helpers/methods/helpers';
  import store from '../../store/store';

  export default {
    data: function () {
      return {
        selectedLocation: null,
        preselectLocationId: null
      };
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    components: {
      Avatar
    },
    computed: {
      locations() {
        return this.getLocations();
      },
      client() {
        return this.getClientByLocationId(this.selectedLocation.idLocation);
      },
      bookingParams() {
        return {
          firstName: this.client.firstName,
          lastName: this.client.lastName,
          email: this.getEmail(),
          phonePrefix: store.state.userData.AppActiveUser.phonePrefix,
          phone: store.state.userData.AppActiveUser.phoneNumber,
        };
      },
      ...mapGetters({
        getClientByLocationId: "getClientByLocationId"
      }),
      ...mapState({
        cachedFiles: state => state.userData.AppActiveFiles
      })
    },
    methods: {
      getWindowWidth() {
        return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      },
      isMobile() {
        return this.getWindowWidth() < 800;
      },
      onlineBookingUrl() {
        return this.selectedLocation.miniWebsite + '/' + '?' + this.serializeParams(this.bookingParams);
      },
      // @todo move to helpers
      serializeParams(obj) {
        var str = [];
        for (var key in obj) {
          if (obj[key] !== null && typeof obj[key] !== 'undefined') {
            str.push(key + '=' + encodeURIComponent(obj[key]));
          }
        }
        return str.join('&');
      },
      getEmail() {
        if (helpers.isEmail(store.state.userData.AppActiveUser.email)) {
          return store.state.userData.AppActiveUser.email;
        } else {
          if (helpers.isEmail(this.client.email)) {
            return this.client.email;
          }
        }
        return null;
      }
    },
    created() {
      const dataURL = window.location.href.split("/");

      if (dataURL.length >= 5) this.preselectLocationId = dataURL[4];

      if (this.locations.length === 1) {
        this.selectedLocation = this.locations[0];
      }

      if (this.locations.length > 0 && this.preselectLocationId) {
        const location = this.locations.find(l => l.idLocation === this.preselectLocationId);

        if (!location.miniWebsite) return;

        this.selectedLocation = location;
      }
    },
  };
</script>

<style scoped>
.online-booking {
  width: 100%;
  height: 100%;
}
.create-appo /deep/ .vs-card--content {
  margin-bottom: 0 !important;
  height: 100%;
}
.online-booking-card {
  height: 100%;
}
.vs-col-online-booking {
  width: 100% !important;
}
.vc-card-online-booking {
  height: 100%;
}

</style>
